// lib
import Wishlist from 'lib/wishlist';
import { component } from 'picoapp';

export default component((node) => {
  node.value = Wishlist.getShareableURL();
});
